import React, { FC } from 'react';
import i18n from 'i18n';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { ModalProps } from '../types';
import { RowsContainer } from '../Common';
import Modal from '../../Modal/index';
import { ModalImageContainer } from '../../ImageContainer/ModalImageContainer';
import { ModalGrayText } from '../../Common';
import App from '../../../../models/app';
import { maxTileNumber } from '../../../../constants';

import Icon from '../../Icon';
import EditIconWhite from '../../../../icons/ic_edit_white.png';

const InstallContentContainer = styled(RowsContainer)`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 0px;
  margin-bottom: 25px;
  align-items: center;
`;

const AppBannerDiv = styled.div`
  margin-bottom: 15px;
`;

const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  gap: 10px;
`;

type ReduxProps = ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: any) => {
  const {
    installedTiles
  } = state.registry

  let tiles = [];
  if (installedTiles && Object.keys(installedTiles).length > 0) {
    tiles = Object.keys(installedTiles).map((tileId: any) => App.selectFromState(tileId, state))
  }

  return {
    tiles
  }
}

interface TooManyTilesModalProps extends ModalProps, ReduxProps {

}

const TooManyTilesModal: FC<TooManyTilesModalProps> = ({ app, onCancel, onSuccess, deviceName }) => (
  <Modal
    id={`TooManyTilesModal`}
    title={i18n('component.InstallTileModal.title')({ appName: app.name })}
    onClose={onCancel}
    contentCenter={
      <InstallContentContainer>
        <AppBannerDiv>
          <ModalImageContainer app={app} deviceName={deviceName} />
        </AppBannerDiv>
        <ModalGrayText>
          {i18n('component.InstallTileModal.content')({ deviceName: deviceName, tileName: app.name, maxTileNumber})}
        </ModalGrayText>
      </InstallContentContainer>
    }
    buttons={[
      {
        text: i18n('component.InstallTileModal.cancelText')(),
        onClick: onCancel,
        testType: 'cancel-button',
        id: 'uninstall-button-cancel'
      },
      {
        text: <LinkContainer>
          <Icon
            id={`manage-tiles-button`}
            aria-label={`manage-tiles-button`}
            url={EditIconWhite}
            width={19}
            height={19}
          />
          {i18n('page.ManageTiles.titleNoNumber')()}
        </LinkContainer>,
        testType: 'manage-button',
        id: 'manage-button-tiles',
        highlight: true,
        to: '/v2/my_tiles',
        pageDirection: 'FORWARD'
      }
    ]}
  />
);

export default connect(mapStateToProps)(TooManyTilesModal);
